import { useContext } from 'react'

import { ParametrizationCurveDepedentsCDContext } from '@provider/Parametrization/CurveDepedentsCDProvider'

import { ICurveDepedentsCDProvider } from '@base/@types/providers/Parametrization/CurveDepedentsCDProvider'

export default function useParametrizationCurveDepedentsCD(): ICurveDepedentsCDProvider {
  const context = useContext(ParametrizationCurveDepedentsCDContext)

  return context
}
